import Test from '../models/Test';
import Section from '../models/Section';
import DisplayItem from '@/models/DisplayItem';
import InstructionalItem from '@/models/InstructionalItem';

class TestConverter {
  static convertTest(test: Test): Array<DisplayItem> {
    const items: Array<DisplayItem> = new Array<DisplayItem>();
    test.testParts.forEach((testPart) => {
      testPart.sections.forEach((section) => {
        TestConverter.handleSections(section, items);
      });
    });

    this.setCurrentItemIfNecessary(items);
    if (items.length > 0) {
      items[0].section.releasedByProctor = true;
    }

    return items;
  }

  private static setCurrentItemIfNecessary(items: Array<DisplayItem>) {
    if (items.findIndex((item) => item.currentItem) === -1) {
      items[0].currentItem = true;
    }
  }

  private static handleSections(section: Section, items: Array<DisplayItem>) {
    section.subSections.forEach((subSection) => {
      TestConverter.handleSections(subSection, items);
    });

    section.rubricBlocks.forEach((rubricBlock) => {
      if (rubricBlock.use === 'instructions') {
        items.push(new InstructionalItem(section, rubricBlock.contentBody));
      }
    });

    section.items.forEach((item) => {
      items.push(item);
    });
  }
}

export default TestConverter;
